/**
 * @generated SignedSource<<e1fc42b1fde628375e6e76f800dff1a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CaseArticlesQuery$variables = {};
export type CaseArticlesQuery$data = {
  readonly caseArticles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly title: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"CaseArticles_case">;
      } | null;
    } | null>;
  } | null;
};
export type CaseArticlesQuery = {
  response: CaseArticlesQuery$data;
  variables: CaseArticlesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CaseArticlesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CaseArticleConnection",
        "kind": "LinkedField",
        "name": "caseArticles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CaseArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CaseArticle",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CaseArticles_case"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CaseArticlesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CaseArticleConnection",
        "kind": "LinkedField",
        "name": "caseArticles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CaseArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CaseArticle",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "articleStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6522a91a5118b5227fb10c075ab93705",
    "id": null,
    "metadata": {},
    "name": "CaseArticlesQuery",
    "operationKind": "query",
    "text": "query CaseArticlesQuery {\n  caseArticles {\n    edges {\n      node {\n        id\n        title\n        ...CaseArticles_case\n      }\n    }\n  }\n}\n\nfragment CaseArticles_case on CaseArticle {\n  articleStatus\n  description\n}\n"
  }
};
})();

(node as any).hash = "2c1b9bc699516daf41339a8f746565c3";

export default node;
